import { SORT_DIRECTION__ASC } from 'react-redux-app/lib/modules/table/constants';
import { SITES_GRID_NAME } from '../constants';

import { defaultFilter as defaultFilterBase } from '../../queryFilter/constants';

import { getGridFilterByName } from '../../queryFilter/utils/gridFilter';


export const getDefaultFilter = () => ({
  ...defaultFilterBase,
  sortField: 'siteName',
  sortDirection: SORT_DIRECTION__ASC,
});

export const getGridFilter = location => (
  getGridFilterByName(location, SITES_GRID_NAME, getDefaultFilter())
);

export const getWebmasterSiteUrl = hostName => `https://${hostName}`;
